export const defaultState = {
  id: null,
  fullName: '',
  email: '',
  course: null,
  courseOption: null,
  name: '',
  completionDate: null,
  cpdHours: '',
  competencies: [],
  competencyOptions: [],
  isProgramme: false,
  programmeSubset: '',
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    const item = action.payload;
    const competencies = (item.competencies || []).map((c) => ({
      value: `${c.type}:${c.id}`,
      label: c.name,
      type: c.type,
      entityId: c.id,
    }));

    // Named the same way the picker names it, so reopening a training shows the
    // course exactly as it was chosen.
    const courseLabel = item.courseOrganizationName
      ? `${item.courseName} (${item.courseOrganizationName})`
      : item.courseName;

    return {
      ...state,
      id: item.id,
      fullName: item.fullName || '',
      email: item.email || '',
      course: item.courseId,
      courseOption: item.courseId ? { value: item.courseId, label: courseLabel } : null,
      name: item.name || '',
      completionDate: item.completionDate ? new Date(item.completionDate) : null,
      cpdHours: item.cpdHours ?? '',
      competencies,
      isProgramme: !!item.isProgramme,
      programmeSubset: item.programmeSubset || '',
    };
  }

  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
